module.exports = __webpack_public_path__ + "static/media/zola-logo-minimal-white.71dd191a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/logos/zola-logo-minimal-white.svg
 ** module id = 941
 ** module chunks = 44
 **/